import * as React from 'react';
import * as _ from 'underscore';

import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { ParameterField } from '../../../_common/platform/tsx/ParameterField';
import NumberField from '../../../_common/platform/ts/NumberField';
import { validators as Validators } from '../../../_common/platform/ts/validators';

export function IntegerNumberField(props: {
    value?: number;
    title?: string;
    validators?: any[];
    glob: IGlob;
    onChange?(value: number): void;
}) {
    const field = React.useMemo(() => {
        let validators = [Validators.number.integer];

        if (props.validators != null) {
            validators = validators.concat(props.validators);
        }

        return new NumberField(props.glob, props.title ?? '', validators);
    }, [props.validators]);

    const handleValueChange = React.useCallback(
        (value: number) => {
            field.validate(value);
            props.onChange?.(value);
        },
        [field, props.onChange]
    );

    if (field.title !== (props.title ?? '')) {
        field.title = props.title ?? '';
    }

    return (
        <div className="integer-number-field">
            <ParameterField param={field} noTitle={props.title == null}>
                <NumberField.EditComponent value={props.value} onChange={handleValueChange} />
            </ParameterField>
        </div>
    );
}
